const version = '__@FLOPFLIP/VERSION_OF_RELEASE__';

export { version };
export { adapter } from './adapter';
